<template>
  <!-- 安全区域 -->
  <div class="area">
    <el-form class="bginput" style="margin-bottom: 0.8rem;" label-width="8rem">
      <el-form-item label="安全区域数据">
        <el-row :gutter="0">
          <el-col :span="6">
            <el-select v-model="set.getType" placeholder="请选择">
              <el-option label="手动录入" :value="0"></el-option>
              <el-option label="后台获取" :value="1"></el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <el-table class="eltabletl" :data="tableData" :span-method="objectSpanMethod" border>
      <el-table-column prop="areaType" label="风险类别" >
        <template slot-scope="scope">
          <span>{{types[scope.row.areaType-1].name}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="areaName" label="区域名称">
      </el-table-column>TopDialogInfo
      <el-table-column prop="risk" label="风险指数">
        <template slot-scope="scope">
          <span v-if="scope.row.risk===1">低</span>
          <span v-if="scope.row.risk===2">中</span>
          <span v-if="scope.row.risk===3">高</span>
        </template>

      </el-table-column>

      <el-table-column fixed="right" label="操作">
        <template slot="header">
          操作
          <i @click="add" style="font-size: 0.9rem;font-weight: 600;cursor:pointer;position: relative;color: #00ffff;" class="el-icon-circle-plus-outline"></i>
          
        </template>
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click.stop="edit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click.stop="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>

    </el-table>

    <!--详情-->
    <el-dialog v-dialogDrag title="详情" :visible.sync="addDialog" width="33%" :before-close="handleClose">
      <div style="min-height: 10rem">
        <el-form ref="formData" :model="formData" label-width="5rem">

          <el-row :gutter="0">
            <el-col :span="24">
              <el-form-item label="区域名称">
                <el-input maxlength="20" v-model.number="formData.areaName" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            
          </el-row>
          <el-row :gutter="0">
            <el-col :span="12">
              <el-form-item label="风险类别">
                <el-select style="width: 100%;" v-model="formData.areaType" placeholder="请选择">
                  <el-option v-for="(item,i) in types" :key="i" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="风险指数">
                <el-select style="width: 100%;" v-model="formData.risk" placeholder="请选择">
                  <el-option label="低" :value="1"></el-option>
                  <el-option label="中" :value="2"></el-option>
                  <el-option label="高" :value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="0">
            <el-col :span="24">
              <el-form-item label="风险原因">
                <el-input maxlength="200" v-model.number="formData.safeCase" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="save">保 存</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import api from '@/apis/safety/area'
export default {
  data() {
    return {
      addDialog: false,
      set: {
        getType: 0,
      },
      types: [
        { id: 1, name: '用能安全重点区域' },
        { id: 2, name: '人员安全区域' },
        { id: 3, name: '设备安全区域' },
        { id: 4, name: '交通安全区域' },
        { id: 5, name: '防火安全区域' },
      ],
      spanArr: [],
      formData: {
        areaName: '', //区域名称
        areaType: '',
        risk: '', 
      },

      tableData: [
        // {
        //   id: '用能安全重点区域',
        //   name: '王小虎22',
        //   amount1: '234',
        //   amount2: '3.2',
        //   amount3: 10,
        // },
        // {
        //   id: '用能安全重点区域',
        //   name: '王小虎22',
        //   amount1: '165',
        //   amount2: '4.43',
        //   amount3: 12,
        // },
        // {
        //   id: '人员安全区域',
        //   name: '王小虎24',
        //   amount1: '324',
        //   amount2: '1.9',
        //   amount3: 9,
        // },
        // {
        //   id: '人员安全区域',
        //   name: '王小虎24',
        //   amount1: '621',
        //   amount2: '2.2',
        //   amount3: 17,
        // },
        // {
        //   id: '人员安全区域',
        //   name: '王小虎24',
        //   amount1: '539',
        //   amount2: '4.1',
        //   amount3: 15,
        // },
        // {
        //   id: '设备安全区域',
        //   name: '王小虎25',
        //   amount1: '539',
        //   amount2: '4.1',
        //   amount3: 15,
        // },
      ],
    }
  },
  mounted() {
    this.getlist()
    
    
  },
  methods: {
    handleClose(done) {
      if (this.flag == 'look') {
        return done()
      }
      this.$confirm('确认关闭？ 数据不会被保存！')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
    add() {
      this.addDialog=true
      this.formData = {
        areaName: '', //区域名称
        areaType: 1,
        risk: 1, //风险指数 1:低 2: 中 3：高
      }
    },
    getlist() {
      api
        .list({
          params: {
            limit: 100,
            page: 1,
          },
        })
        .then((res) => {
          if (res.code === 10000) {
            if (res.data.list.length) {
              this.tableData = res.data.list
            }
          } else {
            this.$message.error(res.message)
          }
          this.getSpanArr(this.tableData) //计算合并的列
        })
    },
    save() {
      api.save([this.formData]).then((res) => {
        if (res.code === 10000) {
          this.$message.success(res.message)
          this.getlist()
          this.addDialog=false
        } else {
          this.$message.error(res.message)
        }
      })
    },
    edit(item){
      this.formData = item
      this.addDialog = true
    },
    del(item) {
      this.$confirm(`确定删除数据？`).then(() => {
        if (item.id) {

          api.del([item.id]).then((res) => {
            if (res.code === 10000) {
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
            this.getlist()
          })
        }
      })
    },
    getSpanArr(data) {
      this.spanArr = []
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1)
          this.pos = 0
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i].areaType === data[i - 1].areaType) {
            this.spanArr[this.pos] += 1
            this.spanArr.push(0)
          } else {
            this.spanArr.push(1)
            this.pos = i
          }
        }
      }
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      row, column

      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col,
        }
      }
    },
  },
}
</script>

<style lang="less">
.area { padding-top: 10px;
  tr.hover-row.current-row > td,
  tr.hover-row.el-table__row--striped.current-row > td,
  tr.hover-row.el-table__row--striped > td,
  tr.hover-row > td {
    background-color: #ffffff00 !important;
  }
}
</style>